import React from 'react';

class ApplianceDetailsContainer extends React.Component {
    render() {
        return this.props.children;
    }
}

export default ApplianceDetailsContainer;
